import gql from 'graphql-tag'

export const GET_VEHICLE_TYPE = gql`
  query VehicleTypes($filter: GetVehicleTypesFilter) {
    vehicleTypes(filter: $filter) {
      isSuccessful
      message
      vehicleTypes {
        data {
          vehicleTypeId
          companyId
          isActive
          manufacturer
          model
          type
          category
          transmissionType
          fuelType {
            fuelTypeId
            name
            category
          }
          tonnage
          volume
          fuelEfficiency
          hasRelation
          formattedVehicleType
        }
        pagination {
          total
          page
          show
        }
      }
      status
    }
  }
`

export const GET_VEHICLE_TYPE_DETAIL = gql`
  query VehicleType($filter: GetVehicleTypeInput!) {
    vehicleType(filter: $filter) {
      isSuccessful
      message
      vehicleType {
        vehicleTypeId
        companyId
        isActive
        manufacturer
        model
        type
        category
        transmissionType
        fuelType {
          fuelTypeId
          name
          category
        }
        tonnage
        volume
        fuelEfficiency
        hasRelation
        icon
      }
    }
  }
`

export const VEHICLE_TYPE_MUTATION_CREATE = gql`
  mutation CreateVehicleType($input: CreateVehicleTypeInput!) {
    createVehicleType(input: $input) {
      isSuccessful
      message
      vehicleType {
        vehicleTypeId
        companyId
        manufacturer
        model
        type
        category
        transmissionType
        fuelType {
          fuelTypeId
          name
          category
        }
        tonnage
        volume
        fuelEfficiency
        icon
      }
    }
  }
`

export const VEHICLE_TYPE_MUTATION_UPDATE = gql`
  mutation UpdateVehicleType($input: UpdateVehicleTypeInput!) {
    updateVehicleType(input: $input) {
      isSuccessful
      message
      vehicleType {
        vehicleTypeId
        companyId
        isActive
        manufacturer
        model
        type
        category
        transmissionType
        fuelType {
          fuelTypeId
          name
          category
        }
        tonnage
        volume
        fuelEfficiency
        icon
      }
    }
  }
`
